import { Grid, Text } from '@approvalmax/ui/src/components';
import { selectors } from 'modules/common';
import { useSelector } from 'modules/react-redux';
import { FC, memo } from 'react';

import { messages } from './HeaderSection.messages';
import { HeaderSectionProps } from './HeaderSection.types';

export const HeaderSection: FC<HeaderSectionProps> = memo((props) => {
    const { useCase, companyDisplayName } = props;

    const profile = useSelector(selectors.profile.findProfile);

    return (
        <Grid gap={8}>
            <Text font='headline' fontSize='small' fontWeight='medium'>
                {messages.title}
            </Text>

            <Text font='body' fontSize='large'>
                {messages.greeting({ name: profile?.name })}

                <div>
                    {messages.useCase({
                        useCase,
                    })}

                    <b>{companyDisplayName}</b>
                </div>
            </Text>
        </Grid>
    );
});

HeaderSection.displayName = 'HeaderSection';
